import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("config", "G-ZMH1NQQ56F", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null; // This component doesn't render anything
}

export default GoogleAnalytics;
